import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LoadingCircleIcon1: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9493 4.59466C16.6817 4.91087 16.7212 5.3841 17.0374 5.65166C17.5373 6.07464 17.9849 6.55098 18.3686 7.0746C18.6134 7.40873 19.0827 7.48115 19.4168 7.23635C19.751 6.99155 19.8234 6.52223 19.5786 6.1881C19.1224 5.56546 18.593 5.00299 18.0063 4.50658C17.6901 4.23902 17.2169 4.27846 16.9493 4.59466Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2258 8.82251C19.8262 8.9315 19.5906 9.34381 19.6996 9.74342C19.9414 10.6299 20.0456 11.5631 19.9738 12.524C19.9429 12.9371 20.2527 13.2969 20.6658 13.3278C21.0788 13.3587 21.4387 13.0489 21.4696 12.6358C21.555 11.4932 21.4304 10.3887 21.1468 9.34875C21.0378 8.94913 20.6255 8.71353 20.2258 8.82251Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3197 14.8929C19.9407 14.726 19.498 14.8979 19.331 15.277C18.7094 16.6882 17.7138 17.8858 16.4716 18.7444C16.1308 18.9799 16.0455 19.447 16.281 19.7878C16.5165 20.1285 16.9837 20.2139 17.3244 19.9784C18.7946 18.9623 19.9702 17.5469 20.7037 15.8816C20.8707 15.5026 20.6988 15.0599 20.3197 14.8929Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5961 18.6234C5.3406 18.9494 5.39779 19.4208 5.7239 19.6763C7.193 20.8275 9.0081 21.5727 11.0091 21.7224C11.9949 21.7956 12.957 21.7181 13.8733 21.5122C14.2774 21.4214 14.5314 21.0202 14.4406 20.6161C14.3498 20.2119 13.9485 19.9579 13.5444 20.0487C12.7692 20.2229 11.9559 20.2886 11.121 20.2266M5.5961 18.6234C5.85159 18.2973 6.323 18.2401 6.649 18.4956L5.5961 18.6234ZM6.649 18.4956C7.8923 19.4698 9.4266 20.0997 11.121 20.2266L6.649 18.4956Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1382 2.25733C6.75121 2.05039 2.21771 6.24854 2.01071 11.6345C1.93301 13.6479 2.48431 15.5307 3.46781 17.119C3.68581 17.4712 4.14811 17.5799 4.50031 17.3618C4.85241 17.1437 4.96111 16.6814 4.74311 16.3293C3.90771 14.9802 3.44401 13.3904 3.50961 11.6924C3.68471 7.13417 7.52131 3.58108 12.0806 3.75623C12.4945 3.77213 12.8429 3.44948 12.8588 3.03557C12.8747 2.62166 12.5521 2.27323 12.1382 2.25733Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
    </svg>
  );
};

export default LoadingCircleIcon1;
